import { DealerManager } from '@/utils/dealerManager';

export interface CertificationStyles {
  header_bg_col: string;
  header_text_col: string;
  corner_radius: number;
  chat_collapsed_icon_bg: string;
  chat_collapsed_icon_text: string;
}

export const DEFAULT_STYLES: CertificationStyles = {
  header_bg_col: '#000000',
  header_text_col: '#FFFFFF',
  corner_radius: 8,
  chat_collapsed_icon_bg: '#000000',
  chat_collapsed_icon_text: '#FFFFFF'
};

// Cache to avoid redundant processing
let cachedStyles: CertificationStyles | null = null;
let cacheTimestamp: number = 0;
let lastDealerId: number | null = null;
const CACHE_DURATION = 60 * 60 * 1000; // 1 hour - branding rarely changes

export const fetchCertificationStyles = async (): Promise<CertificationStyles> => {
  const dealerConfig = DealerManager.getCurrentDealer();
  
  if (!dealerConfig) {
    return DEFAULT_STYLES;
  }

  // Check if we have valid cached styles for the same dealer
  const now = Date.now();
  if (
    cachedStyles && 
    lastDealerId === dealerConfig.dealer_id && 
    (now - cacheTimestamp) < CACHE_DURATION
  ) {
    return cachedStyles;
  }

  // Use branding data bundled in the dealer-auth response (no extra REST calls needed)
  const appliedStyles: CertificationStyles = {
    header_bg_col: dealerConfig.header_bg_col || DEFAULT_STYLES.header_bg_col,
    header_text_col: dealerConfig.header_text_col || DEFAULT_STYLES.header_text_col,
    corner_radius: dealerConfig.corner_radius ?? DEFAULT_STYLES.corner_radius,
    chat_collapsed_icon_bg: dealerConfig.chat_collapsed_icon_bg || DEFAULT_STYLES.chat_collapsed_icon_bg,
    chat_collapsed_icon_text: dealerConfig.chat_collapsed_icon_text || DEFAULT_STYLES.chat_collapsed_icon_text
  };

  // Cache the result
  cachedStyles = appliedStyles;
  cacheTimestamp = now;
  lastDealerId = dealerConfig.dealer_id;
  
  return appliedStyles;
};

export const clearStylesCache = () => {
  cachedStyles = null;
  cacheTimestamp = 0;
  lastDealerId = null;
};
